import { useState, useEffect } from "react";

export function useOrderTime(orderCreatedAt: string) {
  const [orderTimePassed, setOrderTimePassed] = useState("");

  useEffect(() => {
    if (!orderCreatedAt) return;

    // Initial calculation
    calculateTimePassed();

    // Update the time passed every minute
    const interval = setInterval(calculateTimePassed, 60000);

    // Cleanup
    return () => clearInterval(interval);

    function calculateTimePassed() {
      try {
        const createdAtDate = new Date(orderCreatedAt);
        const now = new Date();

        // Validate the date
        if (isNaN(createdAtDate.getTime())) {
          console.error("Invalid order created_at date:", orderCreatedAt);
          setOrderTimePassed("justNow");
          return;
        }

        const diffInMinutes = Math.floor(
          (now.getTime() - createdAtDate.getTime()) / (1000 * 60)
        );

        if (diffInMinutes < 1) {
          setOrderTimePassed("justNow");
        } else if (diffInMinutes < 60) {
          setOrderTimePassed(`${diffInMinutes}m ago`);
        } else {
          const hours = Math.floor(diffInMinutes / 60);
          const minutes = diffInMinutes % 60;
          setOrderTimePassed(`${hours}h ${minutes}m ago`);
        }
      } catch (e) {
        console.error("Error calculating order time:", e);
        setOrderTimePassed("justNow");
      }
    }
  }, [orderCreatedAt]);

  return {
    orderTimePassed,
  };
}
